module.exports = __webpack_public_path__ + "media/newstyle/images/icon-logo-blog-white-6b8139dbab111242ffd866ec276116a8.svg";